export const message_types = {
  immediate: 1,
  time: 2,
  deactive: 3,
};
